import { isMsalRedirectBridgePath, runMsalRedirectBridge } from './app/msal-redirect-bridge';

/**
 * The MSAL redirect bridge page must not boot the application.
 *
 * msal-browser v5 loads `auth.redirectUri` both on the visible redirect return leg and
 * inside a hidden iframe on every silent token renewal. Booting Bundesmaster there would
 * (a) run `MsalRedirectComponent`, which `index.html` hosts as `<app-redirect>`, consuming
 * the IdP response before the bridge could forward it, and (b) pay a full app boot on
 * every token refresh.
 *
 * Both branches are dynamically imported so the bundler splits them: this entry chunk
 * deliberately contains no `@angular/*` or `@azure/msal-*` code.
 */
if (isMsalRedirectBridgePath()) {
	void runMsalRedirectBridge();
} else {
	void import('./bootstrap').then((module) => module.bootstrap());
}
